import { Utils } from 'mw-style-react';

export const GET_REF_BOOKS = Utils.createRequestTypes('GET_REF_BOOKS');
export const CREATE_REF_BOOK = Utils.createRequestTypes('CREATE_REF_BOOK');
export const REMOVE_REF_BOOK = Utils.createRequestTypes('REMOVE_REF_BOOK');
export const UPDATE_REF_BOOK = Utils.createRequestTypes('UPDATE_REF_BOOK');
export const SEARCH_REF_BOOKS = Utils.createRequestTypes('SEARCH_REF_BOOKS');
export const GET_REF_BOOK_USAGE =
  Utils.createRequestTypes('GET_REF_BOOK_USAGE');
export const GET_REF_BOOK = Utils.createRequestTypes('GET_REF_BOOK');

export const SET_REF_BOOKS_REQ_STATUS = 'SET_REF_BOOKS_REQ_STATUS';
export const CLEAR_REF_BOOKS = 'CLEAR_REF_BOOKS';
